import { useEffect } from 'react'
import { useViewContext } from '@renderer/overlay/Sidepanel/view-context'
import { trackStagedActionShown, type StagedActionShownSurface } from './track-staged-action'
import type { StagedAction } from './types'

/** Reports `shown` once the action has loaded; pass `undefined` while its content is hidden. */
export function useTrackStagedActionShown(action: StagedAction | undefined, surface: StagedActionShownSurface) {
  const { entryKey, sourceLabel } = useViewContext()
  useEffect(() => {
    if (action) trackStagedActionShown(action, { surface, entryKey, openedFrom: sourceLabel })
  }, [action, surface, entryKey, sourceLabel])
}
